import { Component, EventEmitter, Inject, Input, OnInit, Output, forwardRef } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { EventDetailsPageDialogComponent } from "../../dashboard-area/event-details/event-details-page-dialog.component";
import { Alert } from "../../model";
import { AlertDefinitionService } from "../../service/alert-definition.service";
import { UiService } from "../../service/ui.service";
import { DurationFormatterPipe } from "../../shared/pipe";
import { EventSeverityPipe } from "../../shared/pipe/event-severity.pipe";
import { ChartData } from "./daily-summary-grid-widget.component";

@Component({
    selector: 'daily-summary-grid-widget-event-details',
    template: require('./daily-summary-grid-widget-event-details.component.html'),
    styles: [require('./daily-summary-grid-widget-event-details.component.css')]
})
export class DailySummaryGridWidgetEventDetailsComponent implements OnInit {

    @Input() set data(data: ChartData) {
        this._data = data;
        this.computeTableData();
    }

    @Input() timezone: string;

    @Input() locale: string;

    @Output() closeDetails = new EventEmitter<void>();

    title: string;
    visibleColumns: string[];
    tableData: Alert[];
    _data: ChartData;
    clickableTable: boolean;
    dataLoaded: boolean;

    constructor(
        @Inject(forwardRef(() => EventSeverityPipe)) private eventSeverityPipe: EventSeverityPipe,
        @Inject(forwardRef(() => DurationFormatterPipe)) private durationFormatterPipe: DurationFormatterPipe,
        @Inject(forwardRef(() => MatDialog)) private dialog: MatDialog,
        @Inject(forwardRef(() => AlertDefinitionService)) private alertDefinitionService: AlertDefinitionService,
        @Inject(forwardRef(() => UiService)) private uiService: UiService
    ) { }

    ngOnInit(): void {
        this.visibleColumns = ['title', 'severity', 'duration', 'start', 'end'];
    }

    private computeTableData(): void {
        this.dataLoaded = false;
        if (this._data?.value.eventHighlights?.length) {
            let tableData = this._data.value.eventHighlights;
            this.title = this._data.category;
            this.alertDefinitionService.getAlertDefinitionById(tableData[0].alertDefinitionId).then(alertDef => {
                tableData.sort((a, b) => a.startTimestamp - b.startTimestamp);
                tableData.forEach(e => {
                    e['printedSeverity'] = this.eventSeverityPipe.transform(e['eventSeverity']);
                    e['duration'] = this.durationFormatterPipe.transform({ startTimestamp: e.startTimestamp, endTimestamp: e.endTimestamp });
                });
                this.clickableTable = !!alertDef.templateName || !!this.uiService.getEventDetailsTemplate();
                this.tableData = tableData;
                this.dataLoaded = true;
            });
        } else {
            this.title = null;
            this.tableData = [];
            this.dataLoaded = true;
        }
    }

    openEventDetails(element: Alert): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.autoFocus = false;
        dialogConfig.minWidth = '25%';
        dialogConfig.data = { id: element.id, isHistorical: !element.endTimestamp };
        this.dialog.open(EventDetailsPageDialogComponent, dialogConfig);
    }
}